import { ingresoFirma } from '../objects/objectToken';
import axios from 'axios';

export const APIToken = {
  getUrl: () => {
    const urlToken =
      ingresoFirma.origen === 'PS'
        ? // ? `${process.env.REACT_APP_ENV_API}/v1/api/prospectos/onboarding/ingresoFirma` // api prospectos nestjs
          `${process.env.REACT_APP_ENV_API}/v1/api/onboarding/tunel` // api onboarding
        : `${process.env.REACT_APP_ENV_API}/v1/api/onboarding`; // api onboarding

    return axios.post(urlToken, ingresoFirma);
  },
};
